{
  "drawMoreButton": "dibujar más campos",
  "drawPolygonInstructions": "Dibuja tu polígono tocando el mapa.",
  "fieldLabelsToggle": "Mostrar/ocultar etiquetas de campos",
  "fieldTypePolygon": "Polígono",
  "helpBodyText": "Cree campos para representar las áreas de su granja. Los campos se utilizan para realizar un seguimiento de los equipos y los eventos de riego.",
  "helpTitle": "Acerca de la creación de campos",
  "linkTo": "Nuevo campo",
  "manageFieldButton": "Administrar campo",
  "notEnoughPoints": "Asegúrese de que su campo tenga al menos 3 puntos y esté cerrado.",
  "restartButtonText": "Reanudar",
  "retartButton": "Empezar de nuevo",
  "setNameInstructions": "Introduzca un nombre para su campo.",
  "setRowDirectionInstructions": "Utilice el control deslizante para establecer la dirección de las filas de su campo.",
  "successInstructions": "Su campo ha sido creado.",
  "title": "Nuevo campo",
  "undoButtonText": "Deshacer"
}
